/* @flow */
import * as React from 'react';

import type { ColumnHeader } from '../ComposableTable';
import ComposableTableHeader from '../ComposableTableHeader';
import type { ComposableTableHeaderSortProps } from '../ComposableTableHeader';

export function getHeader(
  header: ColumnHeader,
  sortProps?: ?ComposableTableHeaderSortProps,
  topOffset?: number,
  index: number,
  spreadsheet?: boolean
) {
  return (
    <ComposableTableHeader
      columnHeader={header}
      sortProps={sortProps}
      key={header.name}
      topOffset={topOffset}
      index={index}
      spreadsheet={spreadsheet}
    />
  );
}
